export const CREATE_CUSTOM_AREA_REQUESTED = 'CREATE_CUSTOM_AREA_REQUESTED';
export const CREATE_CUSTOM_AREA_SUCCEEDED = 'CREATE_CUSTOM_AREA_SUCCEEDED';
export const CREATE_CUSTOM_AREA_FAILED = 'CREATE_CUSTOM_AREA_FAILED';
export const ADD_CUSTOM_AREA = 'ADD_CUSTOM_AREA';
